<template>
  <div
    v-if="hasSamples !== null"
    class="type-headline-sm flex items-center gap-8"
    :class="hasSamples ? 'text-text-attention' : 'text-text-subtle'"
  >
    <GlobalIcon
      :name="hasSamples ? 'check' : 'close'"
      size="xsmall"
      :color="hasSamples ? 'attention' : 'subtle'"
      class="!w-12 !h-12 shrink-0"
    />
    {{ hasSamples ? $t('findRetailer.hasDisplaySamples') : $t('findRetailer.hasNoDisplaySamples') }}
  </div>
</template>

<script setup lang="ts">
import type { RetailersApiItem } from '#constants/types/norce';

const props = defineProps<{
  store: Pick<RetailersApiItem, 'inventoryDate' | 'samplesCount'>,
}>();

// null when the store is not inventoried, a missing count counts as 0
const hasSamples = computed(() => {
  if (!props.store.inventoryDate) {
    return null;
  }
  return (props.store.samplesCount ?? 0) > 0;
});
</script>
